// src/main.js
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createHead } from '@vueuse/head'

import App from './App.vue';

//pages
import Home from './pages/Home';
import Plans from './pages/Plans';
import Blogs from './pages/Blogs';
import BlogItem from './pages/BlogItem';
import Contact from './pages/Contact';
import GetStarted from './pages/GetStarted';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import Privacy from './pages/Privacy';

import 'bootstrap';
import "@/styles/style.scss";

// Set up Axios globally
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Define routes
const routes = [
  { path: '/', component: Home },
  { path: '/plans', component: Plans },
  { path: '/blog/', component: Blogs, props: true },
  { path: '/blog/:slug', component: BlogItem, props: true },
  { path: '/contact-us/', component: Contact },
  { path: '/get-started/', component: GetStarted },
  { path: '/terms', component: Terms },
  { path: '/privacy', component: Privacy },
  { path: '/cookies', component: Cookies },
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App)
const head = createHead()


// Create and mount app
app.use(router)
app.use(head)
app.mount('#app')
